import { observer } from 'mobx-react'
import PlayDashboardPage from 'pages/PlayDashboardPage'

/**
 * `/dashboard` is the merged cross-team landing surface. The new (formerly
 * "play") dashboard draft replaces the old org dashboard UI for every role.
 *
 * The file is intentionally retained as the route entry point — the underlying
 * widgets (RecentView, DraftView, WorkPlanView, ...) live on under
 * `./components/*` for reuse on follow-up surfaces; they're just no longer
 * mounted here.
 */
const DashboardPage = () => <PlayDashboardPage />

export default observer(DashboardPage)
